import api from '../../../api';
import formatUserData from "../../../utils/formatUserData";
import store from "../../index";

export default {
	GET_SUBSCRIPTIONS({dispatch, commit}, userDetails) {
		console.info("GET_SUBSCRIPTIONS");
		console.time("GET_SUBSCRIPTIONS");

		return api.crm.getSubscriptions(userDetails).then(userData => {
			dispatch('UPDATE_ONBOARDING_STATE', userData);
		}).catch((error) => {
			throw {global: "Invalid Dynamo Contact Id."};
		});
	},
	UPDATE_SUBSCRIPTIONS({dispatch, rootState}, crmid, preferences) {
		let userDetails = {
			crmid: crmid,
			preferences: preferences
		};
		return api.crm.updateSubscriptions(userDetails)
			.then(updatedData => dispatch('UPDATE_ONBOARDING_STATE', updatedData));
	},
	GET_ONBOARDING_DATA({dispatch, commit}) {
		console.info("GET_ONBOARDING_DATA");
		console.time("GET_ONBOARDING_DATA");

		return api.crm.retrieveUserRecord().then(userData => {
			if (!userData) {
				dispatch('user/RETRIEVE_USER', {}, {root: true}).then(() => {
					let userData = formatUserData(store.state.user.user);

					commit('user/UPDATE_USER_DATA', {
						userData: userData.user,
						source: 'cognito'
					}, {root: true});
					dispatch('UPDATE_ONBOARDING_STATE', userData);
				});
			} else {
				commit('user/UPDATE_USER_DATA', {
					userData: userData.user,
					source: 'cognito'
				}, {root: true});
				dispatch('UPDATE_ONBOARDING_STATE', userData);
			}

		});
	},
	UPDATE_ONBOARDING_DATA({dispatch, rootState}, preferences) {
		console.info("UPDATE_ONBOARDING_DATA");
		console.time("UPDATE_ONBOARDING_DATA");

		const cognitoOnboardingComplete = rootState.user.user.onboardingcomplete;


		return api.crm.updateUser(preferences)
			.then(updatedData => dispatch('UPDATE_ONBOARDING_STATE', updatedData))
			.then(() => {
				if (cognitoOnboardingComplete === 'Not Completed') {
					return dispatch('user/REFRESH_SESSION', {
						onboardingcomplete: 'Completed'
					}, {root: true})
				}
			});
	},
	UPDATE_ONBOARDING_STATE({commit}, userData) {
		console.info("UPDATE_ONBOARDING_STATE");
		console.time("UPDATE_ONBOARDING_STATE");


		const {form, clubs_supported, subscriptions, disable_communication_group} = userData;

		commit('UPDATE_ONBOARDING_STATE', {form});
		commit('UPDATE_CLUBS_STATE', {clubs_supported});
		commit('UPDATE_DISABLE_COMMUNICATION_GROUP_STATE', {disable_communication_group});

		if (subscriptions.length) {
			const subscriptionsNames = subscriptions.map(subscription => subscription['ffa_name']);
			commit('UPDATE_LEAGUES_AND_MORE_STATE', {subscriptionsNames});
		} else {
			commit('UPDATE_LEAGUES_AND_MORE_STATE', {subscriptionsNames: []});
		}
	},
	SKIP_PREFERENCES_SELECTION({dispatch}) {
		console.info("SKIP_PREFERENCES_SELECTION");
		console.time("SKIP_PREFERENCES_SELECTION");

		return api.crm.skipPreferenceSelection()
			.then(() => {
				dispatch('GET_ONBOARDING_DATA')
			})
			.then(() => {
				dispatch('user/REFRESH_SESSION', {
					onboardingcomplete: 'Skipped'
				}, {root: true})
			});
	},
	SKIP_PREFERENCES_SELECTION_REGO({dispatch}) {
		console.info("SKIP_PREFERENCES_SELECTION_REGO");
		console.time("SKIP_PREFERENCES_SELECTION_REGO");

		api.crm.skipPreferenceSelectionRego()
			.then(() => {
				dispatch('GET_ONBOARDING_DATA')
			})
			.then(() => dispatch('user/REFRESH_SESSION', {
				onboardingcomplete: 'Skipped'
			}, {root: true}));
	},
	UPDATE_USER_OFFERS_REGO({dispatch, rootState}, offers) {
		console.info("UPDATE_USER_OFFERS_REGO");
		console.time("UPDATE_USER_OFFERS_REGO");

		const cognitoOnboardingComplete = rootState.user.user.onboardingcomplete;


		return api.bangeo.saveUserOffers(offers)
			.then(updatedData => dispatch('UPDATE_ONBOARDING_STATE', updatedData))
			.then(() => {
				if (cognitoOnboardingComplete === 'Not Completed') {
					return dispatch('user/REFRESH_SESSION', {
						onboardingcomplete: 'Completed'
					}, {root: true})
				}
			});
	},
	CLEAR_ONBOARDING_STATE({commit}) {
		console.info("CLEAR_ONBOARDING_STATE");
		console.time("CLEAR_ONBOARDING_STATE");

		commit('CLEAR_STATE');
		// commit('CLEAR_ONBOARDING_STATE');
		// commit('CLEAR_CHECKBOX_STATE');
		// commit('CLEAR_CLUB_STATE');
		// commit('CLEAR_LEAGUE_STATE');
		// commit('CLEAR_SETTINGS_STATE');
		// commit('CLEAR_PIORITYTICKETING_STATE');
	},
	GET_DTA_CONFIG() {
		console.info("GET_DTA_CONFIG");
		console.time("GET_DTA_CONFIG");

		return api.bangeo.getDtaConfig();
	},
	OPTIN(_, userData) {
		console.info("OPTIN");
		console.time("OPTIN");

		return api.crm.optin(userData);
	},
	GET_OPTIN_OFFERS(_, userData) {
		console.info("GET_OPTIN_OFFERS");
		console.time("GET_OPTIN_OFFERS");

		return api.crm.getOptInOffers();
	}
};